@let testimonialVal = testimonial();

<div class="testimonial-container">
  <span class="testimonial-text">
    {{ testimonialVal.text }}
  </span>
  <div class="testimonialist-container">
    <img class="avatar" [ngSrc]="testimonialVal.avatarSrc" width="72" height="72" alt="" />
    <div class="testimonialist">
      <span class="name">{{ testimonialVal.name }}</span>
      <span class="position">{{ testimonialVal.role }}</span>
    </div>
  </div>
  <svg
    class="quotes"
    width="105"
    height="92"
    viewBox="0 0 105 92"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.929688 56.6154C0.929688 39.1312 3.28866 26.6425 8.00661 19.1493C13.0021 11.3786 20.7728 4.99548 31.3188 0L43.3912 16.2353C34.7879 20.9532 29.2374 25.3937 26.7396 29.5566C24.5194 33.4419 23.4093 39.4087 23.4093 47.457H45.0564V92H0.929688V56.6154ZM61.2917 56.6154C61.2917 39.1312 63.6507 26.6425 68.3686 19.1493C73.3641 11.3786 80.996 4.99548 91.2645 0L103.337 16.2353C94.7336 20.9532 89.1831 25.3937 86.6853 29.5566C84.4651 33.4419 83.355 39.4087 83.355 47.457H105.002V92H61.2917V56.6154Z"
    />
  </svg>
</div>
